import * as React from 'react'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import { useTrackAnalytics } from '../utils/analytics'

// import { track } from '../utils/analytics'

const initialState: QueryContextState = ''
const initialContext: [
  QueryContextState,
  React.Dispatch<QueryContextAction>,
] = [initialState, () => {}]

type QueryContextState = string

type QueryDict = {
  [key: string]: string
}
type QueryContextAction =
  | { type: 'set_query_string'; payload: string }
  | { type: 'append_dict'; payload: QueryDict }

export const QueryContext = React.createContext(initialContext)

type QueryReducer = (
  state: QueryContextState,
  action: QueryContextAction,
) => QueryContextState

const reducer: QueryReducer = (
  state: QueryContextState,
  action: QueryContextAction,
) => {
  switch (action.type) {
    case 'set_query_string':
      return queryString.stringify({
        ...queryString.parse(state),
        ...queryString.parse(action.payload), // in case new queries have been added manually
      })
    case 'append_dict':
      // turn the string into an object, then add the new dict, then return the string
      return queryString.stringify({
        ...queryString.parse(state),
        ...action.payload,
      })
    default:
      throw Error(`Unrecognized action.type of ${action}`)
  }
}

type QueryControllerType = {
  children: JSX.Element
}

export const QueryController: React.FC<QueryControllerType> = React.memo(
  ({ children }) => {
    const track = useTrackAnalytics()
    const [query, reduceQuery]: [
      QueryContextState,
      React.Dispatch<QueryContextAction>,
    ] = React.useReducer(reducer, initialState) // assign for shallow copy
    const value: [
      QueryContextState,
      React.Dispatch<QueryContextAction>,
    ] = React.useMemo(() => [query, reduceQuery], [query])
    let location = useLocation()

    React.useEffect(() => {
      reduceQuery({ type: 'set_query_string', payload: location.search })
      track('pageview')
    }, [location, reduceQuery, track])

    // React.useEffect(() => {
    //     console.log('query changed: new query')
    //     console.log(query)
    // }, [query])

    return (
      <QueryContext.Provider value={value}>{children}</QueryContext.Provider>
    )
  },
)
